import { yupResolver } from '@hookform/resolvers/yup';
import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import { Resolver, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { handleError } from '../../../../shared/functions/handleError';
import { IRefund } from '../../../../shared/interfaces/refund/IRefund';
import { AdminRefundService } from '../service';
import { refundSchema } from './RefundCreate';
import RefundForm from './RefundForm';

const RefundUpdate = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const { handleSubmit, control, watch } = useForm<IRefund>({
    resolver: yupResolver(refundSchema) as unknown as Resolver<IRefund>,
    defaultValues: async () => {
      const response = await AdminRefundService.getSingle(Number(id));
      return response as IRefund;
    },
  });

  const submitHandler = (state: IRefund) => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append('body', JSON.stringify(state));
    if (state?.file) {
      formData.append('file', state?.file);
    }
    AdminRefundService.update(formData, state?.id)
      .then((response) => {
        if (response) {
          navigate(-1);
          enqueueSnackbar(
            t('toasts.successfullyUpdated', { title: state?.title }),
            {
              variant: 'success',
            },
          );
        }
      })
      .catch((err) => handleError(err))
      .finally(() => setIsLoading(false));
  };

  return (
    <form onSubmit={handleSubmit(submitHandler)}>
      <RefundForm
        control={control}
        isLoading={isLoading}
        watch={watch}
        isUpdate
      />
    </form>
  );
};

export default RefundUpdate;
